import QueryBuilder from "../QueryBuilder"

export default class TestimonialRepository {
    constructor(protected contentName: string) {}

    async fetch() {
        const results = await new QueryBuilder()
            .buildQuery(this.contentName, [
                "bannerText",
                "text_highlight",
                "testimonialList",
            ])
            .process()

        return results.getResultInfo()
    }
}
